/**
 * Created by zhengyf on 2017/11/23.
 */

; (function () {

    viewConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
    angular.module('DSSXAPP', ['app.core', 'ui.router']);

    angular
        .module('DSSXAPP')
        .config(viewConfig)
        .controller('DataAdminCtrl', DataAdminCtrl);

    // 路由配置
    function viewConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/index');
        $stateProvider
            .state('index', {
                url: '/index',
                template: '<diagnosis-center></diagnosis-center>'
            })
            .state('keywords', {
                url: '/keywords',
                template: '<keywords></keywords>'
            })
            .state('self-result', {
                url: '/self-result',
                template: '<self-result></self-result>'
            })
            .state('self-product', {
                url: '/self-product',
                template: '<self-product></self-product>'
            })
            .state('traffic-source', {
                url: '/traffic-source',
                template: '<traffic-source></traffic-source>'
            })
            .state('store-overview', {
                url: '/store-overview',
                template: '<store-overview></store-overview>'
            })
    }

    // 控制器
    function DataAdminCtrl() {

        var vm = this;

        vm.c = {
            top: {
                title: '数据分析',
                href: '/data-admin.html'
            },
            bases: [{
                title: '商家星等级',
                href: '/star-rating.html'
            }, {
                title: '新贸节数据直播屏幕',
                href: ''
            }],
            menus: [{
                title: '首页',
                items: [{
                    title: '数据概览',
                    href: '/data-admin.html#!/index'
                }]
            }, {
                title: '流量',
                items: [{
                    title: '店铺概览',
                    href: '/data-admin.html#!/store-overview'
                }, {
                    title: '流量来源',
                    href: '/data-admin.html#!/traffic-source'
                }, {
                    title: '引流关键词',
                    href: ''
                }]
            }, {
                title: '产品',
                items: [{
                    title: '产品分析',
                    href: '/product-analyze.html'
                }, {
                    title: '零效果产品',
                    href: '/data-admin.html#!/self-product'
                }]
            }, {
                title: '客户',
                items: [{
                    title: '访客详情',
                    href: ''
                }, {
                    title: '访客画像',
                    href: '',
                    
                }]
            }, {
                title: '员工',
                items: [{
                    title: '员工管理',
                    href: ''
                }]
            }, {
                title: '行业',
                items: [{
                    title: '关键词指数',
                    href: '/keyword-rate.html',
                    
                }, {
                    title: '行业报告',
                    href: ''
                }, {
                    title: '征税查询',
                    href: ''
                }, {
                    title: '行业热词榜',
                    href: ''
                }, {
                    title: '行业市场分析',
                    href: ''
                }]
            }, {
                title: '其他',
                items: [{
                    title: '数据学堂',
                    href: '',
                    
                }, {
                    title: '数据字典',
                    href: ''
                }, {
                    title: '常见问题',
                    href: ''
                }]
            }]
        };

        vm.f = {
            toggleView: toggleView,
            toggleSubTab: toggleSubTab,
            getLocationPath: getLocationPath
        };

        init();

        function init() {
            console.log('[data admin ctrl init: ]');
        }

        // 切换view
        function toggleView(tab, index) {

            if (index > 1) {
                return;
            }

            toggleTabStatus(tab, index);
            toggleTabStatus(tab[index].subMenus, 0);
        }


        // 切换Tab 状态
        function toggleTabStatus(tab, index) {

            for (var i = 0, len = tab.length; i < len; i++) {
                tab[i].selected = false;

                if (tab[i].subMenus) {
                    for (var j = 0; j < tab[i].subMenus.length; j++) {
                        tab[i].subMenus[j].selected = false;
                    }
                }
            }

            tab[index].selected = true;
        }

        /**
         * 点击每个大tab下的子tab时，切换tab的选中状态
         * @param menuId 大tab的id
         * @param index 小tab的下标
         */
        function toggleSubTab(menuId, index) {

            // 暂时禁掉nav的切换
            if (menuId > 1) {
                return;
            }
            /*if (index > 0) {
                return;
            }*/
            toggleTabStatus(vm.c.menus, menuId);
            toggleTabStatus(vm.c.menus[menuId].subMenus, index);
        }

        function getLocationPath() {
            return location.pathname + location.hash;
        }

    }

})();
